export var COLUMNS_NAME = {
    LIST_NAME: 'name',
    RECORD_TYPE: 'entityTypeName',
    RECORDS: 'recordsCount',
    STATUS: 'isActive',
    SOURCE: 'createdByUsername',
    LAST_UPDATED: 'updatedDate',
    VISIBILITY: 'isPrivate'
};
export var LISTS_VISIBLE_COLUMNS = Object.values(COLUMNS_NAME);
